var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('b-table',{class:`text-center table-${_vm.variant} mb-0`,attrs:{"striped":"","responsive":"","show-empty":"","empty-text":_vm.$lang.notRecordExist,"fields":_vm.fields,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }